"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRID_HEIGHT = exports.GRID_WIDTH = exports.GRID_SELECTION_MOD = void 0;
require("react");
require("@veeam/components");
require("@veeam/components/lib/Grid/types");
require("../../core");
require("./cellRenderers");
var GRID_SELECTION_MOD;
(function (GRID_SELECTION_MOD) {
    GRID_SELECTION_MOD["single"] = "single";
    GRID_SELECTION_MOD["multi"] = "multi";
})(GRID_SELECTION_MOD = exports.GRID_SELECTION_MOD || (exports.GRID_SELECTION_MOD = {}));
var GRID_WIDTH;
(function (GRID_WIDTH) {
    GRID_WIDTH["fit"] = "fit";
    GRID_WIDTH["flex"] = "flex";
})(GRID_WIDTH = exports.GRID_WIDTH || (exports.GRID_WIDTH = {}));
var GRID_HEIGHT;
(function (GRID_HEIGHT) {
    GRID_HEIGHT["auto"] = "auto";
    GRID_HEIGHT["native"] = "native";
})(GRID_HEIGHT = exports.GRID_HEIGHT || (exports.GRID_HEIGHT = {}));
//# sourceMappingURL=types.js.map